export enum PostMessageEvent {
    CancelCardCreation = 'CancelCardCreation',
    CardCreated = 'CardCreated',
    SaveCard = 'SaveCard',
    AccessTokenReceived = 'AccessTokenReceived',
    CardCreationError = 'CardCreationError',
    PinPadAuthorized = 'PinPadAuthorized',
}
